import { render, staticRenderFns } from "./RfrFilePreviewer.vue?vue&type=template&id=48d0c7a1&"
import script from "./RfrFilePreviewer.vue?vue&type=script&lang=js&"
export * from "./RfrFilePreviewer.vue?vue&type=script&lang=js&"
import style0 from "./RfrFilePreviewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports